import { EVehicleType } from './vehicle-type.enum';

/** Vehicle types available when configuring carrier preferences. */
export const vehicleAvailableSet: ReadonlySet<EVehicleType> = new Set([
  EVehicleType.TRAILER,
  EVehicleType.MEGA,
  EVehicleType.FRIGO,
  EVehicleType.BOX,
]);
